// import { MuiChipsInput } from "mui-chips-input";

const calculateRating = (item) => {
  let sum_rating = item?.sum_rating;
  let sum_responses = item?.sum_responses;

  // calculate average rating out of 6
  let avg_rating = (sum_rating / sum_responses) * 6;
  let rating = avg_rating % 1 === 0 ? avg_rating : (avg_rating || 0).toFixed(1);

  return (
    <span>
      {rating} <span className={`text-${item.palette}`}> / </span> 6
    </span>
  );
};

// const imageUrl = process.env.REACT_APP_IMAGE_URL;
const SurveyTabs = ({
  openTab,
  setOpenTab,
  t,
  // inviteEmailAddresses,
  // setInviteEmailAddresses,
  // usersurveylink,
  // selfsurveylink,
  // copied,
  // setCopied,
  // inviteHandler,
  surveyInviteBased,
  // surveyResultsId,
  // surveyClosingDate,
  // participantDetails,
  // userDetails,
  // self_access_is_set,
  // sendEvent,
  surveyResults,
  start_date,
  end_date,
  // all_sum,
}) => {
  return (
    <div className="box-primary survey-box p-6 h-auto survey-tabs">
      {/* {all_sum >= 3 && ( */}
      <button
        className={`survey-tab${openTab === "stats" ? " active" : ""}`}
        onClick={(e) => {
          setOpenTab("stats");
        }}
      >
        {t("tab.stats.title")}
      </button>
      {/* )} */}
      {/* {((surveyInviteBased === true &&
        all_sum >= 3 &&
        surveyResults.survey_closed === null) ||
        all_sum < 3) && (
        <button
          disabled={surveyInviteBased === false}
          className={`disabled:opacity-30 survey-tab${
            openTab === "invite" ? " active" : ""
          }`}
          onClick={(e) => {
            setOpenTab("invite");
          }}
        >
          {t("tab.email.title")}
        </button>
      )} */}
      {/* {((!surveyInviteBased &&
        all_sum >= 3 &&
        surveyResults.survey_closed === null) ||
        all_sum < 3) && (
        <button
          disabled={surveyInviteBased === true}
          className={`disabled:opacity-30 survey-tab${
            openTab === "link" ? " active" : ""
          }`}
          onClick={(e) => {
            setOpenTab("link");
          }}
        >
          {t("tab.url.title")}
        </button>
      )} */}
      {/* {openTab === "link" && (
        <>
          <div className="relative mb-2">
            <label
              htmlFor="inviteUrl"
              className="text-sm w-[110px] mr-3 inline-block align-top"
            >
              {t("tab.url.invite-url.label")}
            </label>
            <div className="inline-block align-top w-[calc(100%-123px)]">
              <input
                type="text"
                name="inviteUrl"
                id="inviteUrl"
                className="text w-full pr-[105px] mb-2"
                value={usersurveylink}
                readOnly
              />
              <button
                id="event-2-invited-by-link"
                onClick={() => {
                  setCopied(true);
                  navigator.clipboard.writeText(usersurveylink);
                  setTimeout(() => {
                    setCopied(false);
                  }, [5000]);
                }}
                className={`button rounded-[7px] ${
                  copied ? "bg-yellow-400" : "bg-secondary"
                } text-primary border-none py-[5px] w-[93px] absolute right-[6px] top-[5px]`}
              >
                {t(
                  copied
                    ? "tab.url.invite-url.cta.copied"
                    : "tab.url.invite-url.cta.share"
                )}
              </button>
              {t("tab.url.invite-url.text")}
            </div>
          </div>
          <div className="relative mb-2">
            <label
              htmlFor="responseTracking"
              className="text-sm w-[110px] mr-3 inline-block align-middle"
            >
              {t("tab.url.tracking.label")}
            </label>
            <div className="inline-block align-middle w-[calc(100%-123px)] bg-[rgba(226,55,107,.5)] text-white rounded-[10px] p-2 text-[10px]">
              {t("tab.url.tracking.text")}
              <ul className="pl-4 list-disc">
                <li>{t("tab.url.tracking.list_item_1")}</li>
                <li>{t("tab.url.tracking.list_item_2")}</li>
                <li>{t("tab.url.tracking.list_item_3")}</li>
              </ul>
            </div>
          </div>
          <div className="relative mb-5">
            <span
              htmlFor="endDate"
              className="font-medium text-[12px] w-[110px] mr-3 inline-block align-middle"
            >
              {t("tab.url.end_date.label")}
            </span>
            {surveyClosingDate ? (
              <span className="inline-block align-middle w-[calc(100%-123px)]">
                {t("tab.url.end_date.text")}{" "}
                <strong>
                  {new Date(surveyClosingDate).toLocaleDateString("en-GB", {
                    year: "numeric",
                    month: "numeric",
                    day: "numeric",
                  })}
                </strong>
              </span>
            ) : (
              "TBD"
            )}
          </div>
          <div className="relative leading-[16px] py-1">
            <a
              className={`font-medium text-[12px] w-[110px] mr-3 inline-block align-middle button rounded-[7px] text-white border-white py-[5px]${
                self_access_is_set && " pointer-events-none opacity-50"
              }`}
              href={`${selfsurveylink}`}
              rel="noreferrer"
              onClick={(e) => {
                sendEvent({
                  event: "launch-selfassessment",
                  eventdata: Date.now(),
                  email: userDetails.email,
                });
              }}
            >
              {t("tab.email.self-assess.cta")}
            </a>
          </div>
        </>
      )} */}
      {openTab === "stats" && (
        <>
          {surveyResults.survey_closed && (
            <div className="relative mb-7">
              <span className="text-lg font-bold">
                {t("tab.results.survey_closed")}
              </span>
            </div>
          )}
          <div className="relative mb-7">
            <span className="text-sm w-[110px] mr-3 inline-block align-top">
              {t("tab.results.survey_title.label")}
            </span>
            <div className="inline-block align-top w-[calc(100%-123px)] font-bold">
              {surveyResults?.title}
            </div>
          </div>
          <div className="relative mb-7">
            <span className="text-sm w-[110px] mr-3 inline-block align-top">
              {t("tab.results.started_on.label")}
            </span>
            <div className="inline-block align-top w-[calc(100%-123px)] font-bold">
              {start_date ? start_date.toLocaleDateString() : "TBD"}
            </div>
          </div>
          <div className="relative mb-7">
            <span className="text-sm w-[110px] mr-3 inline-block align-top">
              {t("tab.results.end_date.label")}
            </span>
            {end_date ? (
              <div className="inline-block align-top w-[calc(100%-123px)] font-bold">
                {end_date.toLocaleDateString()}
                {surveyInviteBased && (
                  <span className="block font-normal text-sm">
                    {t("tab.results.end_date.text")}
                  </span>
                )}
              </div>
            ) : (
              "TBD"
            )}
          </div>
          {surveyResults?.data?.summary?.completion_rate_count !== "N/A" && (
            <div className="relative">
              <span className="text-sm w-[110px] mr-3 inline-block align-bottom">
                {t("tab.results.status.label")}
              </span>
              <div className="inline-block align-top w-[calc(100%-123px)]">
                <span className="text-sm mb-2 block">
                  {surveyResults?.data?.summary?.participant_complete_count}
                  <span className="text-secondary"> / </span>
                  {surveyResults?.data?.summary?.participant_count}
                </span>
                <div className="progress-bar bg-[#281A6A]">
                  <span
                    style={{
                      width:
                        surveyResults?.data?.summary?.completion_rate_count,
                    }}
                    className="!bg-secondary"
                  ></span>
                </div>
              </div>
            </div>
          )}
        </>
      )}
      {/* {openTab === "invite" && (
        <>
          <div className="relative mb-5">
            <label
              htmlFor="invitePerEmail"
              className="text-sm w-[110px] mr-3 inline-block align-top pt-[10px]"
            >
              {t("tab.email.invite-emails.label")}
            </label>

            <MuiChipsInput
              multiline
              sx={{
                "& fieldset": { border: "none" },
              }}
              validate={(chipValue) => {
                const testforerrorsarray = chipValue.split(/[\s,]+/);

                let testforbadformatting = testforerrorsarray.filter(
                  (newchip) =>
                    /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,30}$/i.test(newchip)
                      ? false
                      : true
                );

                let testforduplication = testforerrorsarray.filter((newchip) =>
                  participantDetails.some(
                    (participant) =>
                      participant.email_invite.email_address === newchip
                  )
                );

                let testforself = testforerrorsarray.filter(
                  (newchip) => userDetails.email === newchip
                );

                return {
                  isError:
                    testforbadformatting.length > 0 ||
                    testforduplication.length > 0 ||
                    testforself.length === 1,
                  textError: `${
                    testforbadformatting.length > 0
                      ? `${t(
                          "tab.email.invite-emails.not_valid_message"
                        )}: ${testforbadformatting.join(", ")}\n`
                      : ""
                  } ${
                    testforduplication.length > 0
                      ? `${t(
                          "tab.email.invite-emails.already_sent_message"
                        )}: ${testforduplication.join(", ")}\n`
                      : ""
                  } ${
                    testforself.length === 1
                      ? `${t(
                          "tab.email.invite-emails.send_to_your_email_message"
                        )}: ${testforself[0]}`
                      : ""
                  }`,
                };
              }}
              hideClearAll
              size={"small"}
              name="invitePerEmail"
              id="invitePerEmail"
              className="text inline-top align-middle w-[calc(100%-123px)] pr-[105px] h-[94px] overflow-auto"
              value={inviteEmailAddresses}
              onChange={(chips) => {
                let parsedchips = [];
                chips.forEach((chip) => {
                  parsedchips = [...parsedchips, ...chip.split(/[\s,]+/)];
                });
                setInviteEmailAddresses(parsedchips);
              }}
            />
          </div>

          <div className="relative mb-5">
            <label
              htmlFor="responseTracking"
              className="text-sm w-[110px] mr-3 inline-block align-middle"
            >
              {t("tab.email.tracking.label")}
            </label>
            <div className="inline-block align-middle w-[calc(100%-123px)]">
              <ul className="pl-4 list-disc">
                <li>{t("tab.email.tracking.list_item_1")}</li>
                <li>{t("tab.email.tracking.list_item_2")}</li>
                <li>{t("tab.email.tracking.list_item_3")}</li>
              </ul>
            </div>
          </div>
          <div className="relative mb-5">
            <span
              htmlFor="endDate"
              className="font-medium text-[12px] w-[110px] mr-3 inline-block align-middle"
            >
              {t("tab.email.end_date.label")}
            </span>
            {surveyClosingDate ? (
              <span className="inline-block align-middle w-[calc(100%-123px)]">
                {t("Will close on midnight")}{" "}
                <strong>
                  {new Date(surveyClosingDate).toLocaleDateString("en-GB", {
                    timeZone: "UTC",
                    year: "numeric",
                    month: "numeric",
                    day: "numeric",
                  })}
                </strong>{" "}
                {t("tab.email.end_date.text")}
              </span>
            ) : (
              "TBD"
            )}
          </div>
          <div className="relative leading-[16px] py-1">
            <a
              className={`font-medium text-[12px] w-[110px] mr-3 inline-block align-middle button rounded-[7px] text-white border-white py-[5px]${
                self_access_is_set && " pointer-events-none opacity-50"
              }`}
              href={`${selfsurveylink}`}
              rel="noreferrer"
              onClick={(e) => {
                sendEvent({
                  event: "launch-selfassessment",
                  eventdata: Date.now(),
                  email: userDetails.email,
                });
              }}
            >
              {t("tab.email.self-assess.cta")}
            </a>
            <button
              id="event-2-invited-by-email"
              disabled={inviteEmailAddresses?.length === 0}
              onClick={(e) => {
                e.preventDefault();
                inviteHandler({
                  employee_ids: inviteEmailAddresses,
                  survey_id: surveyResultsId,
                });
              }}
              className="button disabled:opacity-50 bg-secondary text-primary border-none rounded-[7px] w-[110px] py-[6px] absolute right-[6px] top-1"
            >
              {t("tab.email.invite.cta")}
            </button>
          </div>
        </>
      )} */}
    </div>
  );
};

const SurveyResultsBox = ({ item, toggleActive, t, setToggleActive }) => {
  return (
    <div
      className={`survey-box element-${item.palette}${
        toggleActive === item.title ? " active" : ""
      }`}
      id={item.title}
    >
      <div style={{wordBreak: 'break-word', overflowWrap: 'break-word'}}>
        <h4 className="subtitle">{t("surveyResults.category.title")}</h4>
        <h3 className="title-2xl" style={{wordBreak: 'break-word', overflowWrap: 'break-word'}}>{item.title}</h3>
        <p className="title-sm mb-3" style={{wordBreak: 'break-word', overflowWrap: 'break-word'}}>{item.text}</p>
        <p className="subtitle">
          {t("surveyResults.category.subcategories_included")}{" "}
          <span className="w-[21px] h-[21px] leading-[21px] inline-block bg-white rounded-full text-center text-[#232121] ml-10">
            {item.skills.length}
          </span>
        </p>
      </div>
      <div className="absolute bottom-5 lg:bottom-[26px] left-7 lg:left-[35px] right-20 lg:right-24">
        <span className="text-sm mb-1 block">{calculateRating(item)}</span>
        <div className="progress-bar bg-white">
          <span
            style={{
              width: `calc(${item.sum_rating}*100%/${item.sum_responses})`,
            }}
            className={`bg-${item.palette}`}
          ></span>
        </div>
      </div>
      {item.skills && (
        <button
          className="expand-button"
          onClick={(e) => {
            setToggleActive((prior) => {
              return prior === item.title ? null : item.title;
            });
          }}
        ></button>
      )}
    </div>
  );
};
const SurveyTextQuestionBox = ({
  item,
  expandActive,
  setExpandActive,
  view,
  t,
  managerSummary,
}) => {
  const answers = item?.answers?.filter(
    (filtanswer) => filtanswer?.type === view
  );

  // Find AI summary by question ID
  const aiSummary = managerSummary?.questions?.find(
    (summary) => summary.questionId === item.id
  );

  return (
    <div
      className={`text-question-box${
        expandActive === item.id ? " active" : ""
      }`}
      id={item.id}
    >
      <h3>
        {item.text}
        <button
          className="expand-button bg-primary lg:right-8 right-5 top-6"
          onClick={() => {
            setExpandActive((prior) => {
              return prior === item.id ? null : item.id;
            });
          }}
        ></button>
      </h3>

      <div className="text-question-body flex-wrap">
        {answers?.length > 0 ? (
          answers.map((answer) => (
            <div
              key={answer.id}
              className="bg-[#F8F8F8] px-8 py-6 rounded-[14px] mb-3 lg:w-[calc(50%-6px)] lg:even:ml-3 italic text-[#696484]"
            >
              {answer.response}
            </div>
          ))
        ) : view === "summary" && aiSummary ? null : (
          <div className="bg-[#F8F8F8] px-8 py-6 rounded-[14px] mb-3 w-full italic text-[#696484]">
            {t("surveyResults.feedback.no_results")}
          </div>
        )}

        {/* AI Summary for this question */}
        {view === "summary" && aiSummary && (
          <div className="bg-[#F8F8F8] px-8 py-6 rounded-[14px] mb-3 w-full text-[#696484]">
            <div className="mb-4">
              <strong className="text-[#686285]">
                {t("analyze.managers.summary_header") ||
                  "Zusammenfassung der Rückmeldungen"}
              </strong>
              <div className="whitespace-pre-wrap text-sm leading-relaxed mt-2">
                {aiSummary.summary}
              </div>
            </div>

            <p className="text-sm italic mb-4">
              {t("analyze.managers.count_statement", {
                count: aiSummary.count,
              })}
            </p>

            <div className="mt-4">
              <strong className="text-[#686285]">
                {t(
                  "analyze.managers.recommendation_header"
                ) || "Top-Empfehlung:"}
              </strong>
              <div className="whitespace-pre-wrap text-sm leading-relaxed mt-2">
                {aiSummary.recommendation}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
const SurveySummaryResults = ({ item }) => (
  <div className="summary-item">
    <span className="inline-block w-3/5 align-middle">{item.title}</span>
    <span className="inline-block w-2/5 align-middle title-lg text-end">
      {item.result}
    </span>
  </div>
);
const ModalCategories = ({
  item,
  t,
  setToggleActive,
  academylink,
  userDetails,
}) => {
  return (
    <div className={`modal modal-${item.palette}`}>
      <div
        className="overlay"
        onClick={(e) => {
          setToggleActive((prior) => {
            return null;
          });
        }}
      ></div>
      <div className="modal-body">
        <button
          className="close-button"
          onClick={(e) => {
            setToggleActive((prior) => {
              return null;
            });
          }}
        >
          X
        </button>
        <div className="modal-overflow">
          <div className="modal-inner">
            <div
              className={`survey-box element-${item.palette} active `}
              id={item.title}
            >
                            <div style={{wordBreak: 'break-word'}}>
                <h4 className="subtitle">
                  {t("surveyResults.category.title")}
                </h4>
                <h3 className="title-2xl">{item.title}</h3>
                <p className="title-sm mb-3">{item.text}</p>
                <p className="subtitle">
                  {t("surveyResults.category.subcategories_included")}{" "}
                  <span className="w-[21px] h-[21px] leading-[21px] inline-block bg-white rounded-full text-center text-[#232121] ml-10">
                    {item.skills.length}
                  </span>
                </p>
              </div>
              <div className="w-[85%] mt-10">
                <span className="text-sm mb-2 block float-right">
                  {calculateRating(item)}
                </span>
                <p className="title-sm mb-3">{item.text}</p>
                <div className="progress-bar bg-white">
                  <span
                    style={{
                      width: `calc(${item.sum_rating}*100%/${item.sum_responses})`,
                    }}
                    className={`bg-${item.palette}`}
                  ></span>
                </div>
              </div>
            </div>
            {item.skills &&
              item.skills?.map((skill, skill_ind) => {
                return (
                  <SurveyResultsSubCategoryBox
                    userDetails={userDetails}
                    academylink={academylink}
                    key={skill.id}
                    item={skill}
                    parent_palette={item.palette}
                    skill_ind={skill_ind}
                    t={t}
                  />
                );
              })}
          </div>
        </div>
      </div>
    </div>
  );
};

const SurveyResultsSubCategoryBox = ({
  item,
  parent_palette = null,
  skill_ind = null,
  academylink,
  t,
  userDetails,
}) => {
  return (
    <div className="survey-box-sub-category">
      <div style={{wordBreak: 'break-word', overflowWrap: 'break-word'}}>
        <h4 className="font-inter tracking-[.08em]">
          {t("surveyResults.subcategory.title")} {skill_ind + 1 < 10 ? "0" : ""}
          {skill_ind + 1}
        </h4>
        <h3 className="title-xl" style={{wordBreak: 'break-word', overflowWrap: 'break-word'}}>{item.title}</h3>
      </div>
      <div className="mt-3">
        <span className="text-sm mb-1 block">
          {item.questions[0].answer?.rating > 0
            ? item.questions[0].answer?.rating % 1 === 0
              ? item.questions[0].answer?.rating
              : (item.questions[0].answer?.rating || 0).toFixed(1)
            : 0}
          <span className={`text-${parent_palette}`}> / </span>
          {item.questions[0].answer.possible_score_range}
        </span>
        <div
          className={`progress-bar inline-block align-middle w-[calc(100%-130px)] bg-${parent_palette}-light`}
        >
          <span
            style={{
              width: `calc(${item.questions[0].answer.rating}*100%/${item.questions[0].answer.possible_score_range})`,
            }}
            className={`bg-${parent_palette}`}
          ></span>
          {item.questions[0].answer.self_rating > 0 && (
            <span
              className="self-assess-mark"
              style={{
                left: `calc(${item.questions[0].answer.self_rating}*100%/${item.questions[0].answer.possible_score_range})`,
              }}
            >
              <span className="tooltip">
                {t("surveyResults.subcategory.tooltip.self-assess")}{" "}
                {item.questions[0].answer.self_rating}
              </span>
            </span>
          )}
        </div>

        {!userDetails?.company_id?.academy_content_disabled && (
          <a
            href={`${academylink}/${item.questions[0].answer.academy_content_id}`}
            target="_blank"
            rel="noreferrer"
            className="button rounded-[7px] bg-secondary text-primary border-none ml-8 py-[5px] w-[93px] leading-[16px] text-sm"
          >
            {t("surveyResults.subcategory.academy-cta")}
          </a>
        )}
      </div>
      <div className="question-box" style={{wordBreak: 'break-word', overflowWrap: 'break-word'}}>
        <strong className="block mb-1 text-black">
          {t("surveyResults.subcategory.question_title")}
        </strong>
        <div>{item.questions[0].text}</div>
      </div>
    </div>
  );
};

export {
  SurveyTabs,
  SurveyResultsSubCategoryBox,
  SurveySummaryResults,
  SurveyResultsBox,
  SurveyTextQuestionBox,
  ModalCategories,
};
